import Axios from "axios";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const NewsDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [detailData, setDetailData] = useState([]);
  const [prevPost, setPrevPost] = useState(null); //이전글
  const [nextPost, setNextPost] = useState(null); //다음글

  useEffect(() => {
    getDetail(params.idx);
    getPrevNextPosts(params.idx);
  }, [params.idx]);

  const getPrevNextPosts = (currentIdx) => {
    Axios.get("http://micronpharm.com/api/get/patents_prev")
      .then((res) => {
        const patentssList = res.data;

        const currentIndex = patentssList.findIndex(
          (post) => post.idx === parseInt(currentIdx, 10)
        );

        console.log("Current Index:", currentIndex); // 로그 추가

        if (currentIndex !== -1) {
          const prevPost =
            currentIndex > 0 ? patentssList[currentIndex - 1] : null;
          const nextPost =
            currentIndex < patentssList.length - 1
              ? patentssList[currentIndex + 1]
              : null;

          console.log("Prev Post:", prevPost); // 로그 추가
          console.log("Next Post:", nextPost); // 로그 추가

          setPrevPost(prevPost);
          setNextPost(nextPost);
        }
      })
      .catch((err) => {
        console.error("Error fetching news list:", err);
      });
  };

  const getDetail = (key) => {
    Axios.get("http://micronpharm.com/api/get/patents_detail", {
      params: {
        idx: key,
      },
    }).then((res) => {
      const originData = res.data[0];
      setDetailData(originData);
      //console.log(detailData);

      increaseHitCount(key);
    });
  };

  //조회수 증가
  const increaseHitCount = (key) => {
    Axios.post("http://micronpharm.com/api/post/patents_hit", {
      idx: key,
    })
      .then((res) => {
        // 조회수가 성공적으로 업데이트됐을 때의 처리
        console.log("Hit count updated successfully");
      })
      .catch((err) => {
        console.error("Error updating hit count:", err);
      });
  };

  const moveList = () => {
    navigate("/patents");
    window.location.reload();
  };

  const formatDate = (date) => {
    let realDate = moment(date, "YYYY-MM-DD HH:ss").format("YYYY-MM-DD HH:ss");
    return realDate;
  };

  const addStyleToImages = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    // 이미지 태그에 스타일 추가
    doc.querySelectorAll("img").forEach((img) => {
      img.style.maxWidth = "300px"; // 가로 최대 너비
      img.style.maxHeight = "300px"; // 세로 최대 높이
    });

    return doc.body.innerHTML;
  };
  return (
    <div className="sub-wrap">
      <div className="inner_page_title">Patents</div>
      <div className="content">
        <div className="detail_area">
          <div className="detail_header">
            <div className="detail_title">{`${detailData.title}`}</div>
            <div className="detail_sub_header">
              <div className="sub_row">
                <div className="sub_header_text">작성자</div>
                <div className="sub_header_text no_after">{`${detailData.writer}`}</div>
              </div>
              <div className="sub_row">
                <div className="sub_header_text">등록일</div>
                <div className="sub_header_text no_after">
                  {formatDate(detailData.date)}
                </div>
              </div>
              <div className="sub_row">
                <div className="sub_header_text">조회수</div>
                <div className="sub_header_text no_after">{detailData.hit}</div>
              </div>
            </div>
          </div>
          <div className="detail_content_box" style={{ textAlign: "center" }}>
            <img
              style={{ width: "40%" }}
              src={`http://micronpharm.com/uploads/${detailData.image}`}
            />
            <div
              className="detail_content"
              dangerouslySetInnerHTML={{
                __html: addStyleToImages(detailData.content),
              }}
              style={{ textAlign: "center" }}
            ></div>
            {/* <div className="detail_content">{`${detailData.content}`}</div> */}
            <div className="list_btn_box">
              <div className="list_btn" onClick={() => moveList()}>
                LIST
              </div>
            </div>
          </div>

          <div className="sub_row bottom">
            <div className="sub_header_text">첨부파일</div>
            <div className="sub_header_text no_after">
              {detailData.image !== null ? (
                <a
                  href={`http://micronpharm.com/uploads/${detailData.image}`}
                  download={detailData.image}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {detailData.image}
                </a>
              ) : (
                " X "
              )}
            </div>
          </div>
          <div className="detail_bottom_box">
            <div className="bottom_title2">이전글</div>
            {prevPost ? (
              <div
                className="bottom_text"
                onClick={() => navigate(`/patents/detail/${prevPost.idx}`)}
              >
                {prevPost.title}
              </div>
            ) : (
              <div className="bottom_text">이전글이 없습니다.</div>
            )}
          </div>

          <div className="detail_bottom_box">
            <div className="bottom_title">다음글</div>
            {nextPost ? (
              <div
                className="bottom_text"
                onClick={() => navigate(`/patents/detail/${nextPost.idx}`)}
              >
                {nextPost.title}
              </div>
            ) : (
              <div className="bottom_text">다음글이 없습니다.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetail;
